import eventMerge from './eventMerge.js';
import eventQueue from './eventQueue.js';
import config from './config.js';
import consent from './consent.js';
import sdkAdapter from './sdkAdapter.js';
import { mainLog } from './logger.js';

const canTrack = () => config.getConfig()?.enabled && consent.hasConsent();

let consentEnabled = false;

export const trackLayer = {


  init(enabled = false, options = {}) {
    consentEnabled = Boolean(enabled);
    config.mergeConfig(options);
    const cfg = config.getConfig(options);

    eventMerge.addEventName(['default_properties']);

    const trackDefault = eventMerge.prepareSend();

    if (window.brweb && typeof window.brweb.start === 'function') {
      window.brweb.start({
        track: {
          default_properties: trackDefault['default_properties']
        }
      });
      eventMerge.addEvent('start', trackDefault['default_properties']);
      mainLog('[trackLayer:Main] Init', trackDefault['default_properties']);
    } else {
      mainLog('[trackLayer:Main] brweb not found on window');
    }

    if (cfg.enabled) {
      eventQueue.startPolling();
    } else {
      mainLog('[trackLayer:Main] Tracking is disabled, SDK polling not started.');
    }
  },

  get isConsentEnabled() {
    return consentEnabled;
  },

  set isConsentEnabled(value) {
    consentEnabled = Boolean(value);
  },

  canTrack() {
    return config.getConfig()?.enabled && this.isConsentEnabled;
  },

  addEventData(eventName, data) {
    eventMerge.addEvent(eventName, data);
    eventMerge.addEventName(eventName);
    eventMerge.addEventParam(data);
  },

  sendEvents() {
    mainLog('[trackLayer:Main] Send Events ...');
    eventMerge.send();
  },

  addEvents(eventsData) {
    mainLog('[trackLayer:Main] Add Events ', eventsData);
    const items = Array.isArray(eventsData) ? eventsData : [eventsData];

    items.forEach((item) => {
      if (!item || typeof item !== 'object') return;

      const payload = item.payload ?? item;
      if (!payload || typeof payload !== 'object') return;
      if (payload.events) {
        eventMerge.addEventName(payload.events);
      }
      if (payload.params) {
        eventMerge.addEventParam(payload.params);
      }
    });
  },

  getCnf: () => config.getConfig(),
  getSiteId: () => config.getConfig().siteId,
  getEnvironment: () => config.getConfig().environment,
  getCustomer: () => config.getConfig().customer,
  isSdkReady: () => sdkAdapter.isReady(),
  hasUserConsent: () => consent.hasConsent(),
  getEventQueueSize: () => eventQueue.getQueueSize(),
  getAccumulatedEvents: () => eventMerge.getAccumulatedEvents(),
  getEventNames: () => eventMerge.getEventName(),
  getEventParams: () => eventMerge.getEventParam(),
  prepareSend: () => eventMerge.prepareSend(),

};

// Si además necesitas que se auto-inyecte en el objeto global del navegador:
if (typeof window !== 'undefined') {
  window.trackLayer = trackLayer;
}
